import { useIntl } from "@leagueplatform/locales";
import APP_LOGO from "assets/quest/quest-logo-white.svg";
import {
  Image,
  ParagraphText,
  StackLayout,
} from "@leagueplatform/genesis-core";
import { useIsBelowTablet } from "hooks/use-is-below-tablet.hook";
import { useGetAppInitDetails } from "hooks/queries/use-get-app-init-details";
import { useAppFooterLinks } from "./use-app-footer-links.hook";
import { FooterLink } from "./footer-link.component";

export const AppFooter = () => {
  const { footerLinks } = useAppFooterLinks();
  const { formatMessage } = useIntl();
  const isBelowTablet = useIsBelowTablet();
  const { brandingInfo } = useGetAppInitDetails();

  return (
    <StackLayout
      as="footer"
      horizontalAlignment="center"
      css={{
        backgroundColor: "$decorativeBrandPrimaryDark",
        alignItems: isBelowTablet ? "center" : "flex-start",
      }}
    >
      <StackLayout
        orientation={isBelowTablet ? "vertical" : "horizontal"}
        spacing="$twoAndHalf"
        css={{
          width: "100%",
          padding: isBelowTablet ? "$three $oneAndHalf" : "$three 122px",
          justifyContent: isBelowTablet ? "center" : "space-between",
        }}
      >
        <StackLayout
          orientation={isBelowTablet ? "vertical" : "horizontal"}
          spacing={isBelowTablet ? "$two" : "$oneAndHalf"}
        >
          <Image
            src={APP_LOGO}
            alt={formatMessage({ id: "STR_APP_NAME" })}
            width={98}
          />
          <StackLayout
            as="ul"
            orientation="vertical"
            spacing="$oneAndHalf"
            css={{ maxWidth: "220px" }}
          >
            {footerLinks.map(({ url, text, linkProps, onClick }) => (
              <FooterLink
                key={text}
                url={url}
                text={text}
                linkProps={linkProps}
                onClick={onClick}
              />
            ))}
          </StackLayout>
          <ParagraphText
            css={{ color: "$onSurfaceTextReversed", typography: "$label" }}
          >
            {formatMessage(
              { id: "STR_FOOTER_COPYRIGHT" },
              { year: new Date().getFullYear() }
            )}
          </ParagraphText>
        </StackLayout>
        {brandingInfo?.brandingLogo && (
          <StackLayout
            orientation="vertical"
            spacing="$half"
            css={{
              backgroundColor: "$surfaceBackgroundPrimary",
              borderRadius: "$medium",
              padding: "$one $oneAndHalf",
              alignSelf: isBelowTablet ? "flex-start" : "center",
              width: "fit-content",
              maxWidth: "fit-content",
              flex: "none",
            }}
          >
            <ParagraphText
              css={{
                color: "$onSurfaceTextSubdued",
                typography: "$label",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                fontWeight: 700,
              }}
            >
              {formatMessage({ id: "STR_IN_COLLABORATION_WITH" })}
            </ParagraphText>
            <Image
              src={brandingInfo.brandingLogo}
              alt={brandingInfo.brandingLogoAltText}
              css={{ maxHeight: "40px", objectFit: "contain" }}
            />
          </StackLayout>
        )}
      </StackLayout>
    </StackLayout>
  );
};
